import { useState } from 'react';

const useDiscountPanel = () => {
  const [discount, setDiscount] = useState('0');
  const [validationErrors, setValidationErrors] = useState({
    discount: '',
  });

  const onValidate = () => {
    const errors: typeof validationErrors = {
      discount: '',
    };

    if (parseFloat(discount) < 0) {
      errors.discount = 'The provided value cannot be less then 0';
    }

    if (parseFloat(discount) > 99) {
      errors.discount = 'The provided value cannot be higher then 99';
    }

    if (isNaN(parseFloat(discount))) {
      errors.discount = 'The provided value must be a valid number';
    }

    setValidationErrors(errors);
    return Object.values(errors).some((item) => item !== '');
  };

  return {
    discount,
    validationErrors,
    setDiscount,
    onValidate,
  };
};

export default useDiscountPanel;
